export const PRIMARY = '#0288D1';
export const SECONDARY = '#f59f39';

export default {
  row: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  input: {
    flex: 1,
    // padding: 5,
    margin: 5,
  },
  fab: {
    position: 'absolute',
    right: 10,
    bottom: -60,
  },
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
};



// WEBPACK FOOTER //
// ./src/components/styles.js